<div class="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex flex-col">
  <!-- Fixed Top Navigation -->
  <header class="chat-main-header bg-white/95 backdrop-blur-md border-b">
    <div class="container mx-auto px-4 h-full flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-white shadow-lg flex items-center justify-center p-1.5 ring-2 ring-primary-200">
          <img src="assets/logo.svg" alt="Mental Health Chatbot Logo" class="w-full h-full object-contain">
        </div>
        <div>
          <h1 class="text-lg font-bold text-slate-800 text-sm">JoyBot - Mental Health Support</h1>
          <p class="text-xs text-slate-500">Your compassionate companion</p>
        </div>
      </div>
      <nav class="hidden md:flex items-center gap-4 text-sm text-slate-600">
        <a routerLink="/" (click)="reopenChat()" class="hover:text-primary-600 transition-colors">Chat</a>
        <a routerLink="/self-help" class="hover:text-primary-600 transition-colors flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
          </svg>
          Resources
        </a>
        <a routerLink="/emergency" class="px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center gap-1 font-semibold">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          🚨 Emergency
        </a>
        <a routerLink="/admin/dashboard" class="hover:text-primary-600 transition-colors">Admin</a>
        <button *ngIf="!isExited" (click)="confirmExit()" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 hover:bg-slate-100 text-slate-700 transition text-xs font-semibold" title="Exit Chat and Close Session">
          <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          <span>Exit</span>
        </button>
        <button *ngIf="isExited" (click)="reopenChat()" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white transition text-xs font-semibold" title="Start New Chat">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          <span>New Chat</span>
        </button>
      </nav>
      <!-- Small-screen actions: Exit button + hamburger -->
      <div class="md:hidden flex items-center gap-2">
        <button *ngIf="!isExited" (click)="confirmExit()" class="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg border border-slate-200 hover:bg-slate-100 text-slate-700 transition text-xs font-medium" title="Exit">
          <svg class="w-3.5 h-3.5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          <span>Exit</span>
        </button>
        <button *ngIf="isExited" (click)="reopenChat()" class="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white transition text-xs font-medium" title="New Chat">
          <span>+ Chat</span>
        </button>
        <button (click)="toggleMenu()" class="inline-flex items-center justify-center p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" aria-label="Open menu">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>
    </div>
  </header>

    <!-- Off-canvas side menu for small screens (moved to top-level so it's not hidden by inner-card) -->
    <div class="md:hidden">
      <!-- container z is above header (header z=60) so menu overlays header and footer -->
      <!-- only render container when open to avoid stacking issues -->
      <div *ngIf="sideMenuOpen" class="fixed inset-0" style="z-index: 9999;">
        <!-- Backdrop -->
        <div (click)="closeMenu()" class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
        <!-- Panel (slides in from the LEFT) -->
        <aside class="absolute left-0 top-0 h-full w-64 bg-white shadow-2xl" style="z-index:10000; transition: transform 300ms ease;"
               [style.transform]="sideMenuOpen ? 'translateX(0%)' : 'translateX(-100%)'">
          <div class="p-4 border-b flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-white font-bold shadow-md">💚</div>
              <div>
                <div class="text-sm font-semibold">JoyBot</div>
                <div class="text-xs text-slate-500">Menu</div>
              </div>
            </div>
            <button (click)="closeMenu()" class="p-2 rounded-md text-slate-600 hover:bg-slate-100">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
          </div>
          <nav class="p-3">
            <a (click)="reopenChat(); closeMenu()" routerLink="/" class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50">
              <svg class="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"/></svg>
              Chat
            </a>
            <a (click)="closeMenu()" routerLink="/self-help" class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50">
              <svg class="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 1.567-3 3.5S10.343 15 12 15s3-1.567 3-3.5S13.657 8 12 8z"/></svg>
              Resources
            </a>
            <a (click)="closeMenu()" routerLink="/emergency" class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50">
              <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M22 12a10 10 0 10-20 0 10 10 0 0020 0z"/></svg>
              Emergency
            </a>
            <a (click)="closeMenu()" routerLink="/admin/dashboard" class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50">
              <svg class="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-3.866 0-7 3.582-7 8h14c0-4.418-3.134-8-7-8zM12 4v4"/></svg>
              Admin
            </a>
            <button (click)="reopenChat(); closeMenu()" class="w-full mt-3 inline-flex items-center gap-2 justify-center bg-gradient-to-r from-primary-600 to-secondary-600 text-white px-4 py-2 rounded-lg">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
              Start new conversation
            </button>
            <button *ngIf="!isExited" (click)="confirmExit(); closeMenu()" class="w-full mt-2 inline-flex items-center gap-2 justify-center border border-slate-200 text-slate-700 hover:bg-slate-100 px-4 py-2 rounded-lg text-sm font-medium transition">
              <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
              Exit Application
            </button>
          </nav>
        </aside>
      </div>
    </div>

  <!-- Main Chat Container -->
  <main class="flex-1 flex items-stretch chat-main-body" [ngClass]="isExited ? 'overflow-y-auto' : 'overflow-hidden'">
    <div *ngIf="!isExited" class="mx-auto w-full max-w-4xl px-0 md:px-4 mobile-chat-wrapper">
      <section class="bg-white shadow-xl md:rounded-2xl overflow-hidden flex flex-col mobile-card">
        
        <!-- Chat header inside card (desktop only) -->
        <div class="px-6 py-4 border-b flex items-center justify-between bg-gradient-to-r from-primary-50 to-white">
          <div class="flex items-center gap-3">
            <div class="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-white font-bold shadow-md">
              💚
            </div>
            <div>
              <div class="text-sm font-semibold text-slate-800">JoyBot - Mental Health Assistant</div>
              <div class="text-xs text-primary-600 flex items-center gap-1">
                <span class="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
                Available 24/7 • Here to listen
              </div>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <!-- Desktop full badge -->
            <div class="hidden md:block text-xs text-slate-500 bg-slate-100 px-3 py-1.5 rounded-full">
              Powered by NOUN ⭐
            </div>
            <!-- Small screen compact badge (icon only) -->
            <div class="md:hidden flex items-center text-slate-500 bg-slate-100 px-2 py-1 rounded-full" title="Powered by Gemini">
              <svg class="w-4 h-4 mr-1 text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2l2.09 6.26L20 9.27l-5 3.64L16.18 20 12 16.9 7.82 20 9 12.91 4 9.27l5.91-.99L12 2z" />
              </svg>
              <span class="sr-only">Powered by Gemini</span>
            </div>
            <!-- Refresh Button -->
            <button 
              (click)="refreshChat()" 
              class="w-9 h-9 rounded-lg bg-white hover:bg-primary-50 flex items-center justify-center text-primary-600 hover:text-primary-700 transition-all shadow-sm hover:shadow-md border border-primary-200 hover:border-primary-300"
              title="Start a new conversation">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Escalation Banner -->
        <div *ngIf="escalationActive" class="escalation-banner px-6 py-3 border-b border-t bg-orange-50 flex items-center justify-between gap-4" style="margin-top:25px;">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-sm">
              <svg class="w-5 h-5 text-orange-600 animate-spin-slow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.15"/><path d="M22 12a10 10 0 00-10-10" stroke="currentColor" stroke-width="4" stroke-linecap="round"/></svg>
            </div>
            <div>
              <p class="text-sm font-semibold text-orange-800">Connecting you to a support representative</p>
              <p class="text-xs text-orange-600">{{ escalationMessage }}</p>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button (click)="dismissEscalation()" class="text-xs text-orange-700 underline">Dismiss</button>
          </div>
        </div>

        <!-- Messages Container -->
     <div #messageContainer 
       role="log" 
       aria-live="polite" 
       class="message-list flex-1 overflow-y-auto space-y-2 bg-gradient-to-b from-slate-50/50 to-white">
          <div *ngFor="let m of messages; let i = index" 
            class="flex items-end" 
            [ngClass]="{'justify-end': m.sender==='user', 'justify-start': m.sender==='bot'}">
            <!-- Bot Avatar -->
            <div *ngIf="m.sender==='bot'" class="flex-shrink-0 mr-2 md:mr-3">
              <div class="w-8 h-8 md:w-9 md:h-9 rounded-full bg-gradient-to-br from-primary-100 to-secondary-100 text-primary-600 flex items-center justify-center text-lg shadow-sm">
                💚
              </div>
            </div>

            <!-- Message Bubble -->
            <div class="message max-w-[85%] md:max-w-[78%]">
              <div [ngClass]="{
                'bg-gradient-to-r from-primary-600 to-secondary-500 text-white shadow-lg': m.sender==='bot',
                'bg-slate-100 text-slate-800 shadow-md': m.sender==='user'
              }" class="px-4 py-3 rounded-2xl break-words">
                <div class="whitespace-pre-wrap text-sm md:text-base" [innerHTML]="m.html || m.rawHtml || m.text"></div>
                <div class="mt-1 text-[10px] md:text-[11px] opacity-70 text-right" *ngIf="m.timestamp">
                  {{ m.timestamp | date:'shortTime' }}
                </div>
                <!-- Suggested prompts removed per request -->
              </div>
            </div>

            <!-- User Avatar -->
            <div *ngIf="m.sender==='user'" class="flex-shrink-0 ml-2 md:ml-3">
              <div class="w-8 h-8 md:w-9 md:h-9 rounded-full bg-slate-200 text-slate-700 flex items-center justify-center font-semibold shadow-sm">
                U
              </div>
            </div>
          </div>

          <!-- Typing Indicator -->
          <div *ngIf="isTyping" class="flex items-center gap-2 md:gap-3 pl-2">
            <div class="w-8 h-8 md:w-9 md:h-9 rounded-full bg-gradient-to-br from-primary-100 to-secondary-100 text-primary-600 flex items-center justify-center text-lg shadow-sm">
              💚
            </div>
            <div class="typing-dots bg-slate-100 px-3 py-2 rounded-xl inline-flex items-center shadow-sm">
              <div class="dot bg-primary-600 w-2 h-2 rounded-full animate-bounce-slow mr-1"></div>
              <div class="dot bg-primary-600 w-2 h-2 rounded-full animate-bounce-slow mr-1" style="animation-delay:120ms"></div>
              <div class="dot bg-primary-600 w-2 h-2 rounded-full animate-bounce-slow" style="animation-delay:240ms"></div>
            </div>
          </div>
        </div>

        <!-- Fixed Input Area -->
        <div class="px-3 md:px-4 py-3 md:py-4 border-t bg-white mobile-input-fixed">
          <div class="max-w-4xl mx-auto">
            <form (ngSubmit)="sendMessage()" class="flex items-center gap-2 md:gap-3">
              <button type="button" 
                      class="hidden md:inline-flex items-center justify-center p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" 
                      aria-label="emoji">
                😊
              </button>
              <textarea #messageInput 
                        [(ngModel)]="userInput" 
                        name="message" 
                        rows="1"
                        (focus)="onFocus()" 
                        (blur)="onBlur()" 
                        (keydown.enter)="onEnter($event)"
                        placeholder="Share how you're feeling... Press Enter to send"
                        [class.input-expanded]="isFocused"
                        [class.input-collapsed]="!isFocused"
                        class="flex-1 resize-none px-3 md:px-4 py-2 md:py-3 rounded-xl md:rounded-2xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all text-sm md:text-base">
              </textarea>
              <button type="submit" 
                      class="inline-flex items-center gap-2 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white px-4 md:px-5 py-2 md:py-2.5 rounded-xl md:rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 font-semibold text-sm md:text-base">
                <span class="hidden md:inline">Send</span>
                <svg class="w-5 h-5 md:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                </svg>
                <svg class="w-4 h-4 hidden md:inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                </svg>
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>

    <!-- Dedicated Session Safely Closed View -->
    <div *ngIf="isExited" class="mx-auto w-full max-w-2xl px-4 py-6 md:py-10 flex flex-col items-center justify-center my-auto animate-fade-in">
      <div class="w-full bg-white rounded-2xl md:rounded-3xl shadow-xl border border-slate-100 p-6 md:p-8 text-center">
        <!-- Shield / Peace Badge -->
        <div class="w-16 h-16 md:w-20 md:h-20 mx-auto rounded-2xl bg-emerald-50 border-2 border-emerald-200 flex items-center justify-center mb-4 shadow-sm text-3xl md:text-4xl">
          🛡️
        </div>

        <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider mb-3">
          <svg class="w-3.5 h-3.5 text-emerald-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          Session Safely Ended
        </div>

        <h2 class="text-2xl md:text-3xl font-extrabold text-slate-800 mb-2">
          You Have Safely Exited JoyBot
        </h2>

        <p class="text-slate-600 text-xs sm:text-sm md:text-base leading-relaxed max-w-lg mx-auto mb-6">
          Your conversation history and active session were completely cleared from this browser for your privacy and peace of mind.
        </p>

        <!-- Compassionate Reassurance Box -->
        <div class="bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200/80 rounded-2xl p-4 md:p-5 text-left mb-6 shadow-xs">
          <div class="flex items-start gap-3">
            <span class="text-2xl flex-shrink-0 mt-0.5">🌱</span>
            <div>
              <h4 class="text-sm font-bold text-emerald-900 mb-1">Remember, you are never alone.</h4>
              <p class="text-xs md:text-sm text-emerald-800/90 leading-relaxed">
                Taking a break is a sign of self-care. Whatever you are experiencing on your academic journey, you do not have to carry it all at once. JoyBot is here 24/7 whenever you feel ready to talk again.
              </p>
            </div>
          </div>
        </div>

        <!-- Action Options -->
        <div class="space-y-3 max-w-md mx-auto">
          <!-- Start New Chat Button -->
          <button (click)="reopenChat()" 
                  class="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl md:rounded-2xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all text-sm md:text-base cursor-pointer">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"></path>
            </svg>
            <span>Start a New Conversation</span>
          </button>

          <!-- Student Wellness Questionnaire -->
          <a routerLink="/questionaire" 
             class="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl md:rounded-2xl border-2 border-emerald-600/30 hover:border-emerald-600 bg-white hover:bg-emerald-50/50 text-emerald-800 font-semibold transition-all text-sm md:text-base">
            <span>📝</span>
            <span>Take University Wellness Check-in</span>
          </a>

          <!-- Emergency & Self-Help Row -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5 pt-1">
            <a routerLink="/self-help" 
               class="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-xl border border-slate-200 hover:border-slate-300 bg-slate-50 hover:bg-slate-100 text-slate-700 text-xs font-semibold transition">
              <span>📚</span>
              <span>Self-Help Guides</span>
            </a>
            <a routerLink="/emergency" 
               class="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-xl bg-red-50 hover:bg-red-100 border border-red-200 text-red-700 text-xs font-semibold transition">
              <span>🚨</span>
              <span>Crisis Helplines</span>
            </a>
          </div>
        </div>

        <p class="text-xs text-slate-400 mt-6">
          You may also safely close this tab or window.
        </p>
      </div>
    </div>
  </main>
</div>
